import { useRef, useState } from "react";

const touchDist = t => Math.hypot(t[0].clientX - t[1].clientX, t[0].clientY - t[1].clientY);
const touchMid = t => [(t[0].clientX + t[1].clientX) / 2, (t[0].clientY + t[1].clientY) / 2];
const clamp = (n, a, b) => Math.max(a, Math.min(b, n));

// Gestur sentuh halaman pulau: geser 1 jari, cubit 2 jari; movedRef mencegah klik kota setelah geser.
export function usePulauGestures() {
  const [cam, setCam] = useState({ x: 0, y: 0, z: 1 });
  const camRef = useRef({ x: 0, y: 0, z: 1 });
  const gestureRef = useRef(null);
  const movedRef = useRef(false);
  camRef.current = cam;

  function onTouchStart(e) {
    if (e.touches.length === 1) {
      gestureRef.current = { mode: "pan", sx: e.touches[0].clientX, sy: e.touches[0].clientY, cam: camRef.current };
      movedRef.current = false;
    } else if (e.touches.length === 2) {
      gestureRef.current = { mode: "pinch", d0: touchDist(e.touches), m0: touchMid(e.touches), cam: camRef.current };
      movedRef.current = false;
    }
  }
  function onTouchMove(e) {
    const g = gestureRef.current;
    if (!g) return;
    if (g.mode === "pan" && e.touches.length === 1) {
      const dx = e.touches[0].clientX - g.sx;
      const dy = e.touches[0].clientY - g.sy;
      if (Math.abs(dx) + Math.abs(dy) > 5) movedRef.current = true;
      setCam({ x: clamp(g.cam.x + dx, -1400, 1400), y: clamp(g.cam.y + dy, -1400, 1400), z: g.cam.z });
    } else if (e.touches.length === 2) {
      const d = touchDist(e.touches);
      const m = touchMid(e.touches);
      const z = clamp(g.cam.z * (d / (g.d0 || 1)), 0.8, 2.8);
      if (Math.abs(d - g.d0) > 3) movedRef.current = true;
      setCam({
        x: clamp(g.cam.x + (m[0] - g.m0[0]), -1400, 1400),
        y: clamp(g.cam.y + (m[1] - g.m0[1]), -1400, 1400),
        z,
      });
    }
  }
  function onTouchEnd() {
    gestureRef.current = null;
    setTimeout(() => { movedRef.current = false; }, 90);
  }

  return { cam, camRef, movedRef, handlers: { onTouchStart, onTouchMove, onTouchEnd, onTouchCancel: onTouchEnd } };
}
